// src/utils/debugUtils.js

export const debugAuthentication = (isAuthenticated, hasStoredWallets, isEncrypted) => {
    console.log("%c📱 BitDog Wallet Authentication Debug", "font-size: 14px; color: #3b82f6; font-weight: bold;");
    console.log(`🔐 Is Authenticated: ${isAuthenticated}`);
    console.log(`💾 Has Stored Wallets: ${hasStoredWallets}`);
    console.log(`🔒 Is Encrypted: ${isEncrypted}`);
    
    // Check localStorage
    try {
      const sessionKey = localStorage.getItem('bitdog_session_active');
      const pageSession = localStorage.getItem('bitdog_page_session');
      console.log(`🗝️ Session Active in Storage: ${sessionKey || 'not set'}`);
      console.log(`📄 Page Session ID: ${pageSession || 'not set'}`);
    } catch (e) {
      console.log("Error checking localStorage:", e);
    }
    
  };

  